"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _proptypes = require("../../services/proptypes");

var _GridColumnFlex = require("./GridColumnFlex.utils");

require("./GridColumnFlex.css");

var propTypes = {
  className: _propTypes["default"].string,
  textAlign: _proptypes.TextAlignPropType,
  verticalAlign: _proptypes.VerticalAlignPropType
};
var defaultProps = {
  className: undefined,
  textAlign: 'center',
  verticalAlign: 'middle'
};

function GridColumnFlex(_ref) {
  var textAlign = _ref.textAlign,
      verticalAlign = _ref.verticalAlign,
      className = _ref.className,
      passThroughProps = (0, _objectWithoutProperties2["default"])(_ref, ["textAlign", "verticalAlign", "className"]);
  var allClassNames = [className, (0, _GridColumnFlex.getTextAlignClass)(textAlign), (0, _GridColumnFlex.getVerticalAlignClass)(verticalAlign)].join(' ');
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, (0, _extends2["default"])({
    className: "grid-column-flex ".concat(allClassNames)
  }, passThroughProps));
}

;
GridColumnFlex.propTypes = propTypes;
GridColumnFlex.defaultProps = defaultProps;
var _default = GridColumnFlex;
exports["default"] = _default;